export const commonBaseButtonStyles = (theme: any) => ({
  svg: {
    fill: theme.palette.isDarkMode
      ? theme.palette.neutral[900]
      : theme.palette.neutral[500],
  },
  span: {
    color: theme.palette.isDarkMode
      ? theme.palette.neutral[900]
      : theme.palette.neutral[800],
  },
  color: theme.palette.isDarkMode
    ? theme.palette.neutral[900]
    : theme.palette.neutral[800],
  backgroundColor: theme.palette.isDarkMode
    ? theme.palette.neutral[400]
    : theme.palette.neutral[50],
  '&:hover': {
    backgroundColor: theme.palette.isDarkMode
      ? theme.palette.neutral[500]
      : theme.palette.neutral[100],
  },
  gap: theme.spacing(1),
});
